import angular from 'angular';

angular.module('cloudX').component('cxVatRateTypeXedit', {
  transclude: true,
  bindings: {
    vatRate: '<',
    vatType: '<',
    onChange: '&',
    disabled: '<',
  },
  controller: [
    '$scope',
    'optionsSvc',
    'enumCacheSvc',
    'translateListFilter',
    'percentageFilter',
    '$q',
    function($scope, optionsSvc, enumCacheSvc, translateListFilter, percentageFilter, $q) {
      const ctrl = this;
      ctrl.vatTypes = [];
      ctrl.options = [];
      ctrl.internalValue = '';
      ctrl.displayValue = '';
      ctrl.percentages = optionsSvc.getOptions('vatPercentage');
      enumCacheSvc.get('vatType').then(data => {
        ctrl.vatTypes = data.filter(x => x.key !== 0);
        ctrl.options = [
          ...ctrl.percentages.map(x => ({
            id: `0;${x.label}`,
            label: percentageFilter(x.value, 0),
            vatType: 0,
            vatRate: x.value,
          })),
          ...ctrl.vatTypes.map(x => ({
            id: `${x.key};0`,
            label: translateListFilter(x.key, 'vatType', x.name),
            vatType: x.key,
            vatRate: 0,
          })),
        ];
        ctrl.setDisplayValue();
      });

      ctrl.setInternalValue = function() {
        if (ctrl.vatType === null || ctrl.vatRate === null) {
          this.internalValue = null;
          return;
        }
        let vatType = ctrl.vatType;
        if (ctrl.vatRate > 0) vatType = 0;
        let vatRate = '0';
        if (vatType === 0) {
          const vat = ctrl.percentages.find(x => x.value === ctrl.vatRate);
          if (vat) vatRate = vat.label;
        }
        ctrl.internalValue = `${vatType};${vatRate}`;
      };

      ctrl.setDisplayValue = function() {
        if (!ctrl.internalValue) {
          ctrl.displayValue = null;
          return;
        }
        const { label = null } = ctrl.options.find(x => x.id === ctrl.internalValue) || {};
        ctrl.displayValue = label;
      };
      ctrl.save = function(value) {
        if (!value) {
          return $q.when(ctrl.onChange({ vatRate: null, vatType: null }));
        }
        const { vatType = null, vatRate = null } = ctrl.options.find(x => x.id === value);
        return $q.when(ctrl.onChange({ vatRate, vatType }));
      };

      ctrl.$onChanges = function() {
        ctrl.setInternalValue();
        ctrl.setDisplayValue();
      };
    },
  ],

  template: `<a href="" editable-select="$ctrl.internalValue" onbeforesave="$ctrl.save($data)"
  blur="submit" edit-disabled="$ctrl.disabled"
e-ng-options="item.id as item.label for item in $ctrl.options">
  <ng-transclude>
    <span ng-show="$ctrl.displayValue" >{{$ctrl.displayValue}}</span>
    <i class="glyphicon glyphicon-pencil" ng-show="!$ctrl.displayValue"></i>
  </ng-transclude>
 </a>`,
});
